import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65.2079 0.800049H1.31995V50.6H65.2079V0.800049Z" fill="#0052B4" />
    <path
      d="M0.528027 6.20005C0.396027 6.00005 0.528027 0.800049 0.528027 0.800049L6.72803 0.900049L64.68 45.3V50.1H58.48L0.528027 6.20005Z"
      fill="white"
    />
    <path d="M7.26 49.7001L65.076 5.8001V1.1001H58.74L0.132 45.0001L0 49.7001C0 49.7001 7 49.8001 7.26 49.7001Z" fill="white" />
    <path d="M43.5601 0.5H23.2321V50.5H43.5601V0.5Z" fill="white" />
    <path d="M66 17.8H0V33.2H66V17.8Z" fill="white" />
    <path d="M38.28 0.5H27.984V50.5H38.28V0.5Z" fill="#D80027" />
    <path d="M65.3399 21.8H1.31995V29.6H65.3399V21.8Z" fill="#D80027" />
    <path d="M1.31995 3.8V1.5H4.09195L24.5519 17.8H19.1399L1.31995 3.8Z" fill="#D80027" />
    <path d="M64.6799 47.5999V49.5H60.8519L39.8639 33.2H45.1439L64.6799 47.5999Z" fill="#D80027" />
    <path d="M62.1719 1.5H64.6799V3.3L43.5599 18.7V15L62.1719 1.5Z" fill="#D80027" />
    <path d="M3.82795 49.5H1.31995V47.4L22.4399 32V35.7L3.82795 49.5Z" fill="#D80027" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
